interface Props {
  over: string;
  title: string;
  desc?: string;
  linkHref?: string;
  linkLabel?: string;
}

export default function SectionHeading({ over, title, desc, linkHref, linkLabel }: Props) {
  return (
    <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-secondary-700">
          <span className="h-3 w-1 rounded-full bg-secondary-500" />
          {over}
        </p>
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[2rem] md:leading-tight">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {linkHref && (
        <a
          href={linkHref}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition hover:text-primary-900"
        >
          {linkLabel}
          <i className="ri-arrow-right-line text-sm" />
        </a>
      )}
    </div>
  );
}